export default {
  lang: {
    expressOrder: '快递单',
    transferOrder: '转运单',
    storeSet: '仓库设置',
    equipment: '外接设备设置',
    scaleConnect: '磅秤连接设置',
    printerConnect: '打印机连接',
    previewTestPrinter: '预览测试打印',
    selectStoreTip: '请选择您要配置的仓库',
    selectDeviceTip: '请选择外接的设备',
    ok: '确认',
    cancel: '取消',
    close: '关闭',
    noEquip: '无设备',
    scaleInstrument: '磅秤仪器',
    bulkWeightInstrument: '体积重仪器',
    DWSInstrument: 'DWS仪器(HTTP)',
    plugID: '插件ID',
    selectPlugIDTip: '请输入chrome浏览器插件id',
    getID: '确定插件ID',
    downloadScale: '下载磅秤插件',
    port: '端口',
    selectPortTip: '请选择或输入端口',
    selectTip: '请先选择!',
    unKnown: '未知',
    defaultPrinter: '默认打印机',
    printer: '打印机',
    notYet: '--',
    helpDocument: '帮助文档',
    loginOut: '退出登陆',
    VXScan: '微信扫一扫',
    mobileTip: '手机端操作更方便',
    searchLengthTip: '仅转运单号。当长度为30位时截取前8位，其他长度或单号不受影响',
    searchContentTip: '搜索内容不能为空!',
    scanWarning: '请勿扫描确认码!',
    exitTip: '确认退出吗?',
    location: '当前位置',
    warehousing: '入库',
    warehousingFunction: '入库',
    oldVersionEntry: '旧版本入口',
    getStarted: '开始入库',
    youCanChoose: '您可以选用此模式',
    manualScan: '人工扫码',
    findUserNotify: '查找用户。用于异常件时定位用户。',
    submitCodeNotifyOne: '“确认码”下载。',
    submitCodeNotifyTwo: '扫描“确认码”可以代替回车键。',
    stopScanSubmitCode: '请勿扫描“确认码”',
    notFoundNoNotify: '没有查到单号关联的订单',
    singlePackageWarehouse: '单一类型的包裹入库，',
    batchScan: '批量入库',
    capacityScan: '大仓入库',
    largePackageWarehouse: '大批量的同类型包裹入库。',
    capacityPackageWarehouse: '垫盘货入库',
    autoScan: '自动分拣',
    autoSetting: '分拣机接入，分包策略设定',
    batchMode: '批量入库模式',
    scanModel: '人工扫码模式',
    warehouseNo: '入库快递单号',
    warehouseNoSearch: '快递单号查询',
    transshipmentNo: '转运单号',
    entryCustomerNo: '客户进仓号',
    transshipmentNoSearch: '转运单号查询',
    scanPosition: '扫码定位',
    noPlaceholder: '手动录入条码按回车确认订单，否则视为异常件入库',
    noPlaceholderOther: '手动录入条码按回车确认',
    normalOrder: '正常件',
    normalInstore: '正常入库',
    realTimeLens: '实时镜头',
    photoSave: '入库留存',
    warehouseInfo: '入库信息',
    actualWeight: '实际称重',
    packageCodeMode: '包裹码模式',
    length: '长',
    width: '宽',
    height: '高',
    predictionInfo: '预报信息',
    prePiece: '预计件数',
    number: '件数',
    expend: '展开',
    fold: '收起',
    abnormalOrder: '异常件',
    preWeight: '预计重量',
    orderTime: '下单时间',
    sysNo: '系统单号',
    multiPackageInfo: '多包裹信息',
    index: '序号',
    packageCode: '包裹码',
    weighing: '称重',
    photo: '照片',
    remarks: '备注',
    fillTip: '填写留言给客服的信息',
    printLabel: '打印下单面单',
    sheet: '张',
    batchInStore: '批量入库',
    packageQuantity: '包裹数 ',
    totalWeight: '总重量 ',
    addOneGroupPackage: '添加一组包裹',
    batchUpload: '批量上传 ',
    see: '查看',
    confirmCodeDownload: '确认码下载',
    confirmCodeDownloadTip: '使用方法：下载并打印后，贴在地上，用扫码枪对其扫描代表“确认”动作。',
    oneDimCodeDown: '一维码下载',
    qrCodeDown: '二维码下载',
    download: '下载',
    back: '返回上一页',
    userNameLockTip1: '1.用户名锁定时，所有入库都会记入该用户库中 ',
    userNameLockTip2: '2.用户名未锁定时，入库成功后，用户名将会被移除，可通过右上角“用户查找”重新开启。',
    pieceDiff: '件数不符',
    pieceSame: '件数吻合',
    createAbnormalTip1: '是否创建异常件？',
    createAbnormalTip2: '系统无该包裹信息。',
    createAbnormalTipCapacity: '系统无该订单信息，客户进仓号：',
    createAbnormalTip3: '您可扫“确认码”直接创建。',
    createAbnormalTip4: '确认码定位请点击左下角“扫码定位”',
    findUser: '查找用户',
    selectCustomer: '请先选择客户',
    findUserPlaceholder: '请在下方输入要查找的客户会员码',
    lockUser: '锁定用户',
    lockUserTip: '锁定后，所有异常件都将录入到该用户仓库中。',
    piece: '件',
    versionNotSupport: '您的版本尚不支持此功能',
    serviceConsult: '如要了解详情，可咨询客服 400-805-9105',

    goodsEntry: '物品查验',
    newGoodsEntry: '物品清点',
    itemNumber: '品项数量',
    save: '保存',
    averageWeight: '均摊入库重量',
    averageWeightNotify: '此功能开启时，无需输入重量，系统会将总重量均摊到每个物品上。',
    entryItemDetails: '物品明细录入',
    querySuccess: '查询成功',
    delete: '删除',
    entryGoodsComplete: '该包裹已录入商品信息',
    completeEntryGoods: '完成录入',
    addGoods: '添加商品',
    submitPack: '完成打包',
    packagingComplete: '打包操作已完成!',
    enterLength: '请输入长度',
    enterWidth: '请输入宽度',
    enterHeight: '请输入高度',
    enterWeight: '请输入重量',

    printCenter: '打印中心',
    printBill: '打印面单',
    printTip: '打印需安装打印机程序，否则将以PDF格式导出。如有疑问请拨打客服电话：400-000-0000',
    direct: '直发业务',
    gather: '集运业务',
    scanNo: '扫描单号',
    scanNoPlaceholder: '手动录入请按回车键确认',
    orderNoType: '扫描单号类型',
    wayBillType: '打印面单类型',
    orderBill: '下单面单',
    forecastBill: '预报面单',
    mergeBill: '拼袋面单',
    customDefaultAddress: '客户默认地址面单',
    printQuantity: '打印数量',


    currentDataStatistics: '当前数据统计',
    waitingDelivery: '待出库数',
    outboundDelivery: '我的 已出库数',
    outSet: '出库设置',
    directDelivery: '包裹出库',
    capacityDelivery: '邮袋出库',
    printOrderLabel: '打印包裹面单',
    printOrderAndMailBagLabel: '打印包裹及邮袋面单',
    mergeAndEXWarehouseMode: '拼袋并出库模式',
    refresh: '刷新',
    cargoNo: '卡果单号',
    cargoNoSearch: '卡果单号查询',
    packageNo: '打包单号',
    unPackageNo: '拆包单号',
    outPassTime: '出库指令通过时间',
    transportChannel: '运输渠道',
    deliveryArea: '送达地区',

    inside: '库内',
    insideList: '库内列表',
    subcontract: '分包',
    splitOrderNum: '分包数',
    orderStatus: '订单状态',
    operation: '操作',
    scanOperation: '操作',
    viewDetail: '查看详情',
    goPack: '处理',
    pending: '待处理',
    processed: '处理中',
    completed: '已处理',
    subAndPack: '分包并打包',
    Delay: '分包后等待打包指令',
    needPackItem: '需打包物品',
    cargoOtherName: '别名',
    cargoName: '物品名称',
    estimateWeight: '预估重量',
    cargoType: '货物类型',
    generalSundries: '普货/杂货',
    BatteryMotor: '电池、马达、行车、含磁商品',
    liquidPowder: '液体粉末',
    cosmetics: '化妆品/品牌',
    food: '食品',
    needPackCount: '需打包件数',
    packageInfo: '包裹信息',
    noPhoto: '暂无照片',
    takePhoto: '拍照',
    subcontractingInstruction: '分包指令',

    notify: '提示',
    serverErrorNotify: '服务器异常，请稍后重新尝试',
    lastUpdateTime: '最后修改时间',
    operationSuccess: '操作成功！',

    printBag: '打印邮袋面单',
    previewPrintBag: '预览邮袋面单',
    printPack: '打印打包面单',
    printTemporary: '打印临时面单',
    printPackModelNotify: '此模式系统会自动检测并支付完成打包，但整体速度较慢',
    printTemporaryNotify: '临时面单可在管理-打印中心里定位新的打包面单',
    viewBagHistory: '查看拼袋历史',
    selectMergeSheetStyle: '选择邮袋面单样式',
    enterLimitWeight: '输入限重',
    residualWeightForMerge: '邮袋剩余限重',
    completeMergeAndOut: '完成拼袋并出库',
    departure: '出库',
    merge: '拼袋',
    mergeHistory: '已拼邮袋',
    mawbNo: '主单号',
    portDeparture: '起始港',
    portDestination: '目的港',
    flightInfo: '航班信息',
    outTime: '可出库时间',
    scan: '扫描',

    toBeStored: '未入库',
    preOrder:'未入库',
    stored: '已入库',
    inbound:'已入库',
    inStorage: '入库中',
    outBound: '已出库',
    all: '所有',
    today: '今日',
    list: '列表',
    inStorageTime: '入库时间',
    normal: '正常',
    abnormal: '异常',
    irregular:'异常',
    numberOfOrders: '（单数）',
    search: '搜索',
    reset: '重置',
    orderDate: '下单日期',
    warehousingDate: '入库日期',
    equipmentStatus: '设备状态',
    weight: '重量',

    deliveryCountry: '送达国家/地区',
    forecastStatus: '预报状态',
    updateInfo: '修改信息',
    forecastList: '来货预报',
    warehouseOverview: '仓库总览',
    expandAllWarehouse: '展开所有仓库',
    packUpAllWarehouse: '收起所有仓库',
    warehousesName: '所属仓库',
    currentWarehouse: '当前选择仓库',
    notFoundOrder: '未查到指定的订单！',
    orderNotInStorage: '该订单未入库,请先入库！',
    orderSubmitStopModified: '该订单已确认入库信息，无法修改入库信息！',
    go: '前往',

    multipleCargoModel: '该订单下有多个包裹，无法在此模式入库，请切换为 批量入库模式 或 开启包裹码模式',
    multipleCargoInStorageModel: '该件为批量入库模式入库，无法在此模式入库，请切换为批量入库模式',
    singleCargoInStorageModel: '该件为人工扫码模式入库，无法在此模式入库，请切换为人工扫码模式',
    codeHadScan: '该包裹码已被扫描',
    cargoCodeNotNull: '多包裹包裹码不能为空',
    notNullOrZero: '不能为空且不能小于0',
    abnormalOrderInStorage: '异常件已入库',
    orderInStorage: '入库成功',
    orderTemInStorage: '已暂存入库',
    orderNotHadLabel: '该订单没有面单',
    uploadFailed: '上传失败，请刷新重试',

    continue: '继续',
    submit: '确定',
    willCloseOperation: '检测到您当前正在操作中，继续将会关闭操作',

    pendingOrder: '接单列表',
    operationOrder: '操作列表',

    test: '质检',
    insideTest: '库\n内\n质\n检',
    parcelLocation: '所在库位',
    orders: '接单',
    batchOrders: '批量接单',
    start: '开始',
    status: '状态',
    demandTime: '需求时间',

    history: '历史',
    cargoAndExpressNo: '卡果/快递单号',

    toBeTest: '等待质检',
    inTest: '质检中',
    completeTest: '质检完成',
    testServer: '质检服务',

    pleaseFinishFirst: '请先完成捡货',
    grabbedOrder: '抢单成功！',
    grabbedOrderNotify: "接单后将无法取消接单！",
    selectTestOrder: "请选择质检单！",
    testOrderCount: "质检单总数",
    inputCodeNotify: "请录入单号信息！",
    countPackages: "内含包裹数",
    serviceRemarks: "客服备注",
    testRequirements: "质检需求",
    purchasingTest: "代购质检",


    reshelf: "上/下架",
    packagesOnShelf: "已上架包裹",
    wareHouse: "仓库",
    my: "我的",
    parcelShelvesRecord: "包裹上/下架记录",
    code: '单号',
    storageLocation: '库位',
    operatingTime: '操作时间',
    operator: '操作员',
    onShelfSuccess: '成功',
    onShelfFailed: '上/下架失败',
    onShelfWaiting: '等待上/下架操作',
    onShelfScanNotify: '请输入或者扫描货架号！',

    pack: '打包',
    toBePack: '待打包',
    packaged: '已打包',
    packagedSuccess: '打包完成',
    waitingPacked: '等待打包',
    waitingPicked: '等待拣货',
    packing: '打包中',
    packageCreateTime: '打包单创建时间',

    destCountry: '目的国',
    serviceChannel: '物流服务渠道',
    operableNumber: '可操作包裹数',
    task: '任务',
    scanSuccessNoNotify: '请扫描正确的单号！',
    selectPackageNoNotify: '请选择打包单！',
    packageCount: '打包单总数',
    cargoCount: '包裹总数',
    pickedCount: '已分拣数',
    valueAddedServices: '增值服务',
    message: '留言',
    upload: '上传',
    packagePhotos: '打包照片',
    cursorNotify: '使用仪器请将光标点击此处',
    deviceInputError: '设备传入信息有误',
    pickingSuccess: '拣货成功!',
    quantityNotNullOrZero: '件数不能为空且大于0!',
    lengthNotNullOrZero: '长度信息不能为空且大于0!',
    widthNotNullOrZero: '宽度度信息不能为空且大于0!',
    heightNotNullOrZero: '高度信息不能为空且大于0!',
    weightNotNullOrZero: '重量信息不能为空且大于0!',
    noWeightContinue: '检测到重量未录入，是否继续打包?',
    packSuccess: '成功打包!',
    stopPrintContent: '没有可打印的面单!',
    completedPackList: '已完成打包单',
    completedUnpackList: '已完成拆包单',
    startDate: '开始日期',
    endDate: '结束日期',
    packWeight: '后毛量',
    packLWH: '后长宽高',
    packVolume: '后体积',
    packCompletionDate: '完成时间',
    selectNeedPrint: '请选择要打印的订单！',

    completeBagging: '完成拼袋',
    spellBagSetting: '拼袋设置',
    waitMergePackage: '待拼袋打包单',
    mergePackage: '已拼袋打包单',
    pendingCapacityOrder: '暂无运力订单',
    designatedCapacityOrder: '已有运力订单',
    grossWeight: '毛重',
    spelled: '已拼',
    bag: '邮袋',
    directOrder: '直发订单',
    consolidationOrder: '集运订单',
    limitWeightNotify: '限重不能小于0 且 不能低于已拼袋重量',
    setLimitWeight: '请先设置单袋限重',
    exceedWeight: '实际重量已超过可拼袋重量',
    scanned: '已扫描',
    scanCorrectCargoOrder: '请扫描正确的卡果二维码！',
    cargoNotReviewedStopSpell: '该包裹还未审核，无法拼袋！',
    cargoBound: '该包裹已订舱，是否强制拼此袋？',
    cargoRemoved: '该包裹已去除！',
    destCountryNotAssembledStopMerge: '包裹的目的国与已有包裹的目的国不一致，无法拼袋！',
    routeNotAssembledStopMerge: '包裹移库路线与已有包裹的路线不一致，无法拼袋！',
    scanNeedMergeOrder: '请先扫描需要拼袋的订单！',
    selectLabelStyle: '您选择了打印面单，请选择面单样式！',
    addNeedMergePackage: '请先添加需要拼袋的包裹！',
    successMerge: '成功拼袋！',
    pouchNo: '邮袋号',
    shipmentList: '出\n库\n列\n表',
    boundTheMAWB: '已绑定主单号',
    notBoundTheMAWB: '不绑定主单号',
    pouchOutStore: '邮袋号出库',
    transferOrderOutStore: '转运单出库',
    selectMAWB: '请先选择主单',
    orderSent: '出库成功',

    packLabel: '打包面单',
    inputOrScanCode: '请输入或者扫描单号',

    notFoundCodeOrder: '暂不支持此单号打印！',
    notQrCodeSearch: '暂不支持包裹二维码搜索！',
    createTime: '需求日期',
    anomalous: '异常件处理',
    returnOpera: '退库处理',
    batchNum: '处理批次号',
    processingMethod: '处理方式',
    returnGoods: '退货',
    destroy: '销毁',
    lost: '待处理',
    selectOrder: '请先选择订单！',
    countOrder: '订单总数',

    claim: '认领验证',
    claimPic: '验证照片',
    claimTitle: '认\n领\n验\n证',

    locationManage: '库位管理',
    available: '可用',
    deactivate: '停用',
    numLocation: '库位数',
    addAreaNo: '新增分区',
    addLocation: '新增库位',
    allStatus: '全部状态',
    allLocationTypes: '全部库位类型',
    locationTypes: '库位类型',
    areaNum: '分区号',
    shelfNum: '货架号',
    locationNum: '库位编号',
    batchOperationType: '批量操作类型',
    batchOperation: '批量操作',

    pickArea: '拣货区',
    scrapArea: '残品区',
    stockArea: '备货区',
    operationArea: '操作区',
    pcsNumber: '所含PCS数',
    updateTime: '更新时间',
    modifier: '最近修改',
    viewCargo: '查看货物',
    stopListing: '停用',
    reinstatement: '启用',
    locationListTitle: '库\n位\n列\n表',
    batchPrinting: '批量打印条码',
    stoppedInBatches: '批量停止上架',
    resumingInBatches: '批量恢复上架',
    deleteLocationsInBulk: '批量删除库位',
    selectOperationOrders: '请先需要选择需要处理的订单！',
    updateSuccess: '修改成功！',
    deleteNotify: '删除后将无法恢复, 是否继续?',
    deleteSuccess: '成功删除!',
    selectPlease: '请选择',
    limitTwoDigits: '仅限两位数字',
    codeSuggest: '建议编码方式：如A01、A02',
    confirmCreation: '确认创建',
    inputAreaNoPlease: '请输入分区编号！',
    addSuccess: '新增成功！',
    noAreaNumNotify: '若无可选分区号，请先点击"新增分区"创建',
    upToSixDigits: '最多6位数字',
    startLine: '起始行',
    terminationLine: '终止行',
    upToEightLines: '最高8行',
    startColumn: '起始列',
    stopColumn: '终止列',
    upTo100Columns: '最大100列',
    createLocationNum: '此次生成库位数',
    locationPreview: '货架预览',
    numLimit: '货架编号不能小于0或包含小数！',
    startColumnLimit: '起始列不能大于99或小于0、等于0、包含小数！',
    endColumnLimit: '终止列不能大于100或小于0、等于0、包含小数！',
    startOrEndColumnLimit: '终止列不能小于起始列',
    startLineLimit: '起始行不能大于7或小于0、等于0、包含小数！',
    endLineLimit: '终止行不能大于8或小于0、等于0、包含小数！',
    startOrEndLineLimit: '终止行不能小于起始行',
    shelfNumNotNull: '货架编号不能为空！',
    startColumnNotNull: '起始列不能为空！',
    startLineNotNull: '起始行不能为空！',
    stopColumnNotNull: '终止列不能为空！',
    terminationLineNotNull: '终止行不能为空！',

    wareHouseOrderDetail: '订单查询详情',
    basicInfo: '基础信息',
    deliveryMethod: '发货方式',
    directType: '直发',
    transferType: '转运',
    gatherType: '集运',
    orderMemberCode: '下单会员码',
    sendInfo: '寄送信息',
    product: '物流产品',
    spellNo: '拼袋号',
    consigneeName: '收件人姓名',
    consigneeCompany: '收件人公司',
    consigneeProvince: '收件州/省',
    consigneeCity: '收件城市',
    address: '详细地址',
    inBoundInfo: '库内信息',
    allGrossWeight: '总毛重',
    orderOfPackage: '订单包裹数',
    warehousingPic: '入库照片',
    LHW: '长宽高',

    abnormalOrderOpera: '异常订单处理',
    scanPick: '扫描拣货',

    returnAddress: '退货地址',
    shippingCurrency: '运费币种',
    returnShippingFee: '退货运费',

    finish: '完成',
    pickNotComplete: '拣货工作未完成！',
    returnNoNotNull: '退货快递单号不能为空！',
    returnFeeNotNull: '退货运费不能为空！',
    submitSuccess: '成功提交！',
    completeOrder: '已完成处理单',
    completeTime: '处理完成日期',

    check:'效验',
    warehousingTest:'入库质检',
    ProcessingFeedback:'处理反馈信息',
    leaveMessageToCustomer:'给客服留言',
    photoUpload:'照片上传',

    stopUpdateContinue:'后无法修改, 是否继续?',
    finishTestOrder:'已完成质检单',
    finishCheckOrder:'已完成效验单',
    addedItemInfo:'已添加物品信息',
    appendix:'附件',
    notUploaded:'未上传',
    containsDetails:'内含详情',
    volume:'体积',
    viewContainedGoods:'查看内含货物',
    locationInfo:'库位信息',
    packageOrderInfo:'订单信息',
    numOrder:'订单数',
    box:'箱',
    boxNum:'箱数',
    orderer:'下单人',
    billingWeight:'计费重',
    exportPackageExcel:'导出列表',
    ownedMawbNo:'所属主单号',
    mailbagWeight:'邮袋重量',
    containedOrders:'内含订单数',
    selectMailBag:'请选择要导出的邮袋！',
    mailBagParcel:'邮袋包裹',
    modifyWarehousingInfo:'修改入库信息',
    confirmChanges:'确认修改',

    failedToRemove:'下架失败',
    setWeightNotify:'请前往首页设置磅秤,否则磅秤将无法连接！',
    failConnectWeightSuggestOne:'连接磅秤失败，建议重新插拔磅秤与电脑的连接线或重启设备',
    failConnectWeightSuggestTwo:'连接磅秤失败，未找到设备，请前往首页->设置磅秤连接，查看配置问题',
    nothingToPrintYet:'暂无需要打印的内容',
    printFailNotify:'打印失败，可能未安装打印软件等问题，是否重试',
    retry:'重试',
    failGetLabel:'获取面单失败',


    login:'登录',
    loginTitle:'快操作WMS系统',
    account:'账号',
    password:'密码',
    wms:'快操作',


    preWarehouseDeliveryTime:'前置仓库出库时间',
    packageNotBagContinue:'该包裹不在当前邮袋需求中，是否继续添加？',
    notInStoreCannotSpell:'当前邮袋需求包裹没有进入当前仓库，无法添加非此邮袋下的包裹！',
    package:'包裹',
    parcels:'包裹',

    unPack:"开始拆包",
    unPackBag:"邮袋拆包",

    unOpened:"未拆包",
    unPacked:"已拆包",

    packageList:'包裹列表',
    bagList:'邮袋列表',

    cargoCodeModelNotify:"需要录入多个包裹，请开启此功能。 或者可以点击右上角“批量入库模式”。",
    continueWarehousing:"继续入库",

    deviceStatusNormal:'正常',
    chooseOrder:'选择此单',
    chooseNeedInboundOrder:'手动选择需要入库的订单。',
    scanOrderNo:'扫描VEX单号选择订单。',
    norFoundOrder:'未查到对应订单',
    scanVEXCode:'请扫描该订单的VEX单号',
    scanConfirmVEXCode:'请输入/扫描VEX单号,以确认订单',
    saveNext:'暂存，下一单',

    consigneeAddress:'收件地址',
    consignee:'收件人',
    mobile:'电话',
    numOfInclude:'内含物数量',
    unPackCargo:'分拆包裹',
    unPackType:'分包类型',
    unPackSuccess:'已分包',
    onTheShelf:'所在货架',

    originCargoNo:'原始卡果单号',
    inputCargoNameOrOther:'请填写物品名称或别名',
    packageOnShelfRemove:'包裹处于货架上，请先下架。货架位置：',
    orderCollection:'拆包归集',
    unPackHistory:'分包历史',
    selectDeliveryTimes:'请选择订单的出库时间段',
    cargoOnShelf:'包裹上/下架',
    onOffShelf:'上架 / 下架',
    scanCodeOrRackCode:'请扫描单号/库位号：',
    warehouseOnShelf:'仓库 已上架包裹',
    myOnShelf:'我的 已上架包裹',
    onShelfScanOne:'请扫描货架号',
    onShelfScanTwo:'请扫描入库快递单号、卡果单号、包裹码',
    onShelfScanThree:'请扫描货架号、入库快递单号、卡果单号、包裹码',
    onShelf:'上架',
    offShelf:'下架',
    newOrder:'新订单',
    originOrder:'初始订单',
    inWarehouseQuantity:'入库件数',
    inWarehouseWeight:'入库重量',
    inWarehouseVolume:'入库总体积',
    cancelSelectNotSpellBag:'取消勾选的订单，将不会拼到邮袋中',
    printScanNotify:'（临时面单、卡果单号可直接扫描）',
    selectOutTime:'请选择出库日期',
    deliveryTime:'出库时间',
    originOrderQrCode:'原始订单收寄件人识别码',
    collectInputPlaceHolder:'请扫描卡果单号、转运单号',
    scanSplitOrder:'扫描分拆订单',
    scanOriginOrder:'扫描原始订单',
    currentOriginCollect:'当前原始订单归集完成',
    originalOrder:'原始订单',
    current:'当前',
    collected:'已归集',
    collectedAndTotal:'已归集/总包裹',
    splitOrder:'分拆订单',
    splitOrderNo:'分拆订单号',
    notAggregated:'未归集',
    packageNotInSplit:'当前包裹不在当前操作包裹内！',
    scanOriginSplitOrder:'请扫描该原始订单拆分的包裹！',
    scanSuccessOriginOrder:'请扫描正确的原始订单单号！',
    collectSuccess:'归集成功',
    noOrder:'未接单',
    orderReceived:'已接单',
    packScanCargoNotify:'请扫描卡果单号/入库快递单号/包裹码',
    packHistory:'打包历史',
    consigneePhone:'收件人/电话',
    unPackInputPlaceHolder:'请扫描卡果单号、入库快递单号',
    measureSpellBag:'测量邮袋',
    capacityOrder:'运力订单',
    unSpellBag:'待拼袋包裹',
    capacityOrderBound:'是否已绑定运力订单',
    chooseWaybill:'选择邮袋面单样式',
    setBagWeightLimit:'设定邮袋限重',
    packageNotPayPrintTemplate:'打包单尚未支付，无法打印面单！',
    scanCorrectCargoCode:'请扫描正确的包裹单号',
    wrappingWaybill:'包裹面单',
    scanSpellBagMeasure:'邮袋测量',
    scanSuccessShowWeight:'扫描成功后，连接正常会显示实时重量',
    waitScanSpellBag:'等待邮袋扫码',
    measureHistory:'邮袋测量历史',
    measureSuccess:'测量成功',
    scanSpellBag:'请扫描邮袋条码',
    measureInfo:'测量信息',
    lookPicture:'查看照片',
    bagVolume:'邮袋体积',
    bagVolumeAttr:'邮袋长/宽/高',
    printCargoNo: '打印卡果单号',
    searchSpellHistory: '查看拼袋历史（拼袋->已拼邮袋）',
    details: '详情',
    notAssignWarehouse: '您当前尚未分配仓库，请联系管理员',
    unPackFail: '拆包失败',
    packFail: '打包失败',
    reason: '原因',
    currentInWarehouseScanCode: '当前处于入库操作中，请扫描包裹码或确认码',
    outStoreNotifyTitle:'出库检测',
    outStoreNotifyWeightZero:'检测包裹重量为0，',
    outStoreNotifyUnPay:'检测存在未支付费用，',
    sureOpera:"确认操作？",
    outStoreNotifyScanOut:'您可扫“确认码”确认',
    returnExpressNo:'退货快递单号',

    countQuantity:'总件数',
    countWeight:'总毛重',
    countVolume:'总体积重',
    volumeWeight:'体积重',
    volumeRatioSetting:'材积比设置',

    defaultWarehouse:'默认登陆仓库',
    setDefault:'设为默认',

    originalCollectModel:'原始订单归集',
    splitCollectModel:'分包订单归集',

    outWarehouseType:'出库方式',
    spellBagAddOrder:'漏装补装',

    scanPleaseAddOrder:'请扫描漏装补装订单',
    unBind:'解绑',

    ipAddressAndPortCreated:'地址及端口已生成！',
    dwsDeviceSetting:'请将以下生成的内容在DWS配置软件中，自行替换用户端系统的HTTP监听服务的地址和端口(示例红色部分为需要替换的内容)。格口袋号请求 Get 提交方式',
    dwsRequestDemo:'【请求示例】',
    replaceContent:'替换内容',
    operationCloseDialog:'我已操作，关闭弹窗',

    languageSetting:'语言设置',
    setting:'设置',
    seeSetting:'查看配置',
    removeCodeTheFirstStart:'移除单号前',
    removeCodeTheFirstEnd:'位',
    codeOpera:'单号处理',
    onlyExpressAndTransferNo:'仅适用于快递/转运单号',

    poundWeight:'过磅重量',
    receiptSheet:'签收单',
    deliverySheet:'出库单',
    unKnownOrder:'无头件',
    orderInWarehoused:'单号对应订单已入库',
    orderOutWarehoused:'单号对应订单已出库',

    export:'导出',
    sequenceNo:'批次',
    orderHasQuantity:'内含件数',
    capacitySubNo:'分单号',
    capacityNo:'主单号',
    returnOrder:'退库单',

    capacityOrderType:'运单类型',
    air:'空运',
    sea:'海运',

    netWeight:'净重量',
    adviseShipmentTime:'客服通知出货时间',
    printShipmentLabel:'打印出库单',
    shipmentInitiator:'出库发起人',
    exportAndShipment:'导出并出库',
    exportShipmentPlan:'导出出货计划',
    serviceOrderShipment:'客服指令出库',
    serviceOrderRemark:'客服指令备注',
    warehouseShipment:'仓库出库',
    deliveryDate:'交货日期',
    shipmentRemark:'出库备注',
    shipmentPic:'出库照片',
    returnToStorage:'重新入库',
    temporarySave:'暂存',
    printReceiptLabel:'打印签收单',
    remove:'移除',
    submitShipment:'确认出库',
    shipmentInfo:'出库信息',
    shipmentOpera:'出库操作员',
    totalVolume:'总体积',
    withPallet:'含垫托',
    noPallet:'不含垫托',
    palletType:'垫盘种类',
    palletNum:'垫盘数',
    palletWeight:'垫盘重',
    palletSetting:'垫盘设置',
    cargoInfo:'货物信息',
    changeLocation:'更换库位',
    cargoInStorageStatus:'货物入库状态',
    weighingData:'过磅数据',
    cargoSize:'货物尺寸',
    inboundOpera:'入库操作人',
    deliveryCompany:'送货单位',
    licencePlateNo:'车牌号',
    widthDocument:'随货文件',
    without:'无',
    have:'有',
    sealWeight:'关封重',
    preVolume:'预计体积',
    actPieces:'实际件数',
    actWeight:'实际重量',
    actVolume:'实际体积',
    inboundRemark:'入库备注',
    preGrossWeight:'预计毛重',
    packageType:'包装类型',
    cargoIntact:'货物完好',
    cargoWeighing:'过磅',
    cargoBreakage:'破损',
    cargoDampness:'受潮',
    cargoDeformable:'变形',
    cargoMissing:'漏件',
    other:'其他',
    receiptLabelEditing:'签收单编辑',
    inboundNetWeight:'入库净重',
    inboundVolume:'入库体积',
    processingComplete:'处理完成',
    uploadAnnex:'附件上传',
    pickUpLicensePlate:'提货车牌',
    contact:'联系方式',
    returnRemark:'退库备注',
    stockedTime:'当前仓储时间',
    days:'天',
    pleaseRecord:'请记录',
    returnInfo:'退库信息',
    processingRequirements:'处理要求',
    returnWarehouse:'退库',
    inboundSummary:'入库概要',
    returnInitiator:'退库发起人',
    returnInitTime:'退库指令时间',
    storedTime:'已仓储时间',
    returnOperaTime:'退库时间',
    estArrivalDate:'预计到仓日期',
    selectStatusAndTakePic:'选择货物状态并拍照',
    cargoStatus:'货物状态',
    inboundComplete:'完成入库',
    logPieces:'记录件数',
    addNewSize:'添加一组尺寸',
    cargoMarks:'货物唛头',
    palletSetDefaultWeight:'垫托默认重量设置',
    woodPallet:'木托',
    ironPallet:'铁托',
    paperPallet:'纸托',
    cardBox:'纸箱',
    woodBracket:'木托',
    paperDrum:'纸桶',
    canvasRoll:'布卷',
    wovenBag:'编织袋',
    plywoodBox:'夹板箱',
    pagerSupport:'纸托',
    plywoodBracket:'夹板托',
    fba:'FBA',
    commercialExpress:'商业快递',
    smallParcel:'小包件',
    eCommercePackage:'电商件',
    directTransportation:'专线',
    generalCargo:'普货',
    sensitiveGoods:'敏感货',
    dangerousGoods:'危险品',
    totalInBoundPieces:'库内总件数',
    totalInBoundNetWeight:'库内总净重',
    locationModification:'库位区域修改',
    currentLocation:'当前库区',
    selectReplaceLocation:'选择要更换的库区',
    pleaseAddPackage:'至少录入一组过磅重量！',
    groupWeightNotEmpty:'组过磅重量不能为空！',
    groupPiecesNotEmpty:'组件数不能为空或0！',
    groupPalletPiecesNotEmpty:'组垫盘件数不能为空或0！',
    groupPalletWeightNotEmpty:'组垫盘重量不能为空！',
    palletWeightNotExceedPoundWeight:'组垫盘重量不能超过过磅重量！',
    sizeGroupPiecesNotEmpty:'组尺寸件数不能为空或0！',
    sizeGroupLengthNotEmpty:'组尺寸长度不能为空！',
    sizeGroupWidthNotEmpty:'组尺寸宽度不能为空！',
    sizeGroupHeightNotEmpty:'组尺寸高度不能为空！',
    poundWeightPiecesNotMatchSize:'过磅重量件数与货物尺寸件数不一致！',
    piecesNotZero:'的件数不能为0！',
    piecesNotEmpty:'的件数不能为空！',
    noOutBoundOrders:'无可出库订单！',
    pleaseSelectDeliveryTime:'请选择出货时间！',
    service:'客服',
    seeMore:'查看更多',
    licensePlateNotEmpty:'提货车牌不能为空！',
    concatNotEmpty:'联系方式不能为空！',
    pleaseSelectModifyLocation:'请选择需要更换的库位！',
    selectNeedOperaOrder:'手动选择需要操作的订单',
    preCargoAttr:'预计 件/重量/体积',
    poundCargoAttr:'入库 件/过磅重量/体积',
    initReturn:'发起退货',
    returning:'退货中',
    returned:'已退货',

    includeCargos:'内含订单详情',

    previewPrint:'预览打印',
    print:'打印',
    manage:'管理'

  }
}
// export const zh={
//   indexView:{
//     currentLocation:'current location'
//   }
// }



// WEBPACK FOOTER //
// ./src/lang/zh.js